import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import CadastrarInsumoRecord from '@components/InsumoRecord/CadastrarInsumoRecord';
import formatMessage from './i18n/formatMessage';
import Insumo from '@resources/InsumosEnum';
import { withRouter } from 'react-router-dom';

/**
 * Tela para cadastro de nematicida
 *
 * @author Gabriela Farias <gabriela.farias@kepha.com.br>
 * @param {*} props
 * @returns {JSX.Element}
 */
function EditarNematicida(props) {
  useEffect(() => {
    const title = 'nematicidas.cadastroDeNematicidas';
    if (props.itensState.name !== title) {
      props.dispatch({ type: 'UPDATE_TOOLBAR', toolbar: formatMessage(title), name: title });
    }
  }, []);

  return (
    <CadastrarInsumoRecord
      id={props.match.params.id}
      insumoURL={'nematicidas'}
      insumoEnum={Insumo.NEMATICIDA}
      infoUsuario={props.infoUsuario}
      saveMessage={formatMessage(
        'nematicidas.' +
          (props.match.params.id
            ? 'nematicidasEditadoComSucesso'
            : 'nematicidasCadastradoComSucesso')
      )}
      falhaSaveMesssage={formatMessage(
        'nematicidas.' +
          (props.match.params.id
            ? 'falhaAoEditarNematicidas'
            : 'falhaAoCadastrarNematicidas')
      )}
      falhaCarregarMensagem={formatMessage('nematicidas.falhaAoCarregarNematicidas')}
    />
  );
}

const mapStateToProps = state => ({
  itensState: state.toolbar,
  infoUsuario: state.adicionarInfoUsuario.info
});

export default withRouter(connect(mapStateToProps)(EditarNematicida));
